import { z } from 'zod';

/**
 * Opaque ID of an op record. Server-assigned; client never mints these for
 * accepted ops (provisional IDs are an implementation detail of the queue).
 */
export type OpId = string;

export const OpIdSchema = z.string().min(1);
